import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { Cross as CrossIcon } from "@/assets/icons";
import { sanitizeHtml } from "@/core/security";

import {
    BottomSheetAction,
    BottomSheetContainer,
    BottomSheetDescription,
    BottomSheetOverlay,
    BottomSheetTitle,
} from "./styled";

type BottomSheetProps = {
    title: string;
    content: string;
    handleOverlayClick: () => void;
};

export type BottomSheetData = {
    title: string;
    content: string;
};

const BottomSheet: FC<BottomSheetProps> = ({ title, content, handleOverlayClick }) => {
    const { t } = useTranslation();

    return (
        <BottomSheetOverlay onClick={handleOverlayClick}>
            <BottomSheetContainer onClick={(e) => e.stopPropagation()}>
                <BottomSheetTitle>{title}</BottomSheetTitle>
                <BottomSheetDescription
                    dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(content, { ADD_ATTR: ["target"] }),
                    }}
                />
                <BottomSheetAction onClick={handleOverlayClick} aria-label={t("Common.Close")}>
                    <CrossIcon />
                </BottomSheetAction>
            </BottomSheetContainer>
        </BottomSheetOverlay>
    );
};

export default BottomSheet;
